module.exports = __webpack_public_path__ + "img/florbal-hriste.577dd41a.svg";